module.exports = __webpack_public_path__ + "static/desktop/img/diarybook-2.5994abb8.png";